<template>
  <div class="scroll_contain">
    <header-component></header-component>
    <search-view-component
      class="mb-5"
      @onChange="onSearchChange($event)"
      @inputChanged="onSearchInputChange($event)"
      :hideMapButton="true"
      :messageValue="this.searchTerm"
    ></search-view-component>
    <section class="inner-article-container " >
      <div class="page-container">
        <div class="row g-0 align-items-center mb-5">
            <div class="col-12 col-sm-7 mb-5 mb-sm-0">
<!--                class="form-select fs-3 shadow border-0 p-3 rounded-10"-->
                <select v-if="this.showCategories"
                        @change="onChange($event)"
                        style="border: none;font-size: 2vw"
                        aria-label="Default select example"
                        v-model="selectedValue">
                  <option
                    v-for="category in categoriesArray"
                    v-bind:key="category.Id"
                    v-bind:value="category.Id"
                  >
                    {{ category.Name }}
                  </option>
                    <option  key='activated'
                             value="activated"
                    >
                        {{ 'Activated Offers' }}
                    </option>
                </select>

                <div  style="font-weight: bold;font-size: 2.5vw" v-if="!this.showCategories"> Search Results </div>
            </div>
            <div class="col-12 col-sm-5">
                <div class="row g-0 align-items-center">
                  <div class="col-12 col-sm-5 pe-4 text-start text-sm-end">Sort by:</div>
                  <div class="col-12 col-sm-7">
                    <select
                      @change="onChange($event)"
                      class="form-select fs-3 shadow border-0 p-3 rounded-10"
                      aria-label="Default select example"
                      v-model="selectedSortValue"
                    >
                      <option
                        v-for="sortBy in sortArray"
                        v-bind:key="sortBy.Id"
                        v-bind:value="sortBy.Id"
                      >
                        {{ sortBy.Name }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
            <div v-if="showNoResultsFound" style="text-align: center; color:black" >No search results found, please adjust your search and try again.</div>
        </div>
          <div class="loading">
          <transition name="fade">
<!--              <div class="loading" v-show="loading">-->
<!--                  <span class="fa fa-spinner fa-spin"></span> Loading-->
<!--              </div>-->

<!--              <div v-show="loading" class="spinner-border" role="status">-->
<!--                  <span class="visually-hidden">Loading...</span>-->
<!--              </div>-->

              <font-awesome-icon  v-show="loading" icon="fa-solid fa-spinner fa-2xl" spin />
          </transition>
          </div>
        <div class="article-detais-view">
          <offers-block-component
            v-for="(item, index) in this.matchedOffers"
            :key="item.OfferId"
            :offer="item"
          >
          </offers-block-component>
        </div>
<!--          <div style="float:right">-->
<!--              <button @click="next"> Prev </button>-->
<!--              <button v-if="this.showNext" @click="next"> Next </button>-->
<!--          </div>-->
      </div>
    </section>
  </div>
</template>

<script>
import HeaderComponent from "../HeaderComponent.vue";
import SearchViewComponent from "./SearchViewComponent.vue";
export default {
  components: {
    HeaderComponent,
    SearchViewComponent,
  },
  name: "SearchResultsComponent",

  data() {
    return {
      showCategories: true,
      category: this.$route.query.category,
      matchedOffers: [],
      selectedValue: "",
      selectedSortValue: "A-Z",
      categoriesArray: [],
      sortArray: [{ Id: 'A-Z', Name: 'A-Z' }, { Id: 'Z-A', Name: 'Z-A' }, { Id: 'Expiring', Name: 'Expiring' }],
      pageNumber: 1,
      showNext: false,
      searchTerm: null,
      loading: false,
      showNoResultsFound: false,
      prevCategoryMerchantName: (this.$route.query.category || '') + (this.$route.query.search_term || '')
    };
  },
    updated() {
        this.getNextOffers();
    },
  mounted() {

    this.getAndSetAllCategories();
   // console.log(this.$route.query.category, "query");

    let payload = {
        PageNumber: this.pageNumber,
        ItemsPerPage: 16,
    };

    this.selectedValue = this.$route.query.category ? this.$route.query.category : '';

    if(this.selectedValue != 'all') {
            payload.Category = this.selectedValue;
    }

    if(this.selectedSortValue) {
        payload.SortBy = this.selectedSortValue;
    }


    if(this.$route.query.search_term) {
        payload.MerchantName = this.searchTerm = this.$route.query.search_term;
        // console.log(this.searchTerm);
    }

    if(this.$route.query.hideCategories) {
        this.showCategories = false;
        // console.log(this.searchTerm);
    }



    this.getOffers(payload);

    this.getNextOffers();
  },



  methods: {
      getAndSetAllCategories() {
           //this.categoriesArray.push({ Id: "", Name: "Select Category" });

          axios.get(this.apiEndPoints.getAllCategories, {
          })
              .then((response) => {
                  if(response.data && Object.keys(response.data).length) {
                      for (const [key, value] of Object.entries(response.data)) {
                          this.categoriesArray.push({ Id: key, Name: value });
                      }

                      this.selectedValue = this.$route.query.category ? this.$route.query.category : '';
                  }
              })
              .catch((error) => {
                  // console.error(error, 'here');
                  // console.error(error.status,'here')

                  if (error.response.status == 401 || error.response.status == 419) {
                      this.$router.push({ name: 'sign_in' });
                  }
              });
      },
      getNextOffers() {
          window.onscroll = () => {
              let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight > (document.documentElement.offsetHeight - 3);
               console.log(document.documentElement.scrollTop+'-'+window.innerHeight +'-'+ document.documentElement.offsetHeight);
              if (bottomOfWindow) {
                  this.pageNumber = this.pageNumber + 1;

                  let payload = {
                      PageNumber: this.pageNumber,
                      ItemsPerPage: 16,
                  };

                  if(this.selectedValue != 'all') {
                          payload.Category = this.selectedValue;
                  }

                  if(this.selectedSortValue) {
                      payload.SortBy = this.selectedSortValue;
                  }

                  if(this.searchTerm) {
                      payload.MerchantName = this.searchTerm;
                  }

                  this.getOffers(payload);
              }
          }
      },

      onChange(event) {
          this.resetPageNumber();

          let payload = {
              PageNumber: this.pageNumber,
              ItemsPerPage: 16
          };

          if(this.selectedValue != 'all') {
                  payload.Category = this.selectedValue;
          }

          if(this.selectedSortValue) {
              payload.SortBy = this.selectedSortValue;
          }

          if(this.searchTerm) {
              payload.MerchantName = this.searchTerm;
          }

                    // Update URL query parameters
          if (this.selectedValue === 'all') {
              this.$router.push({
                  path: '/search_result',
                  query: {
                      ...this.$route.query,
                      category: undefined
                  }
              });
          } else {
              this.$router.push({
                  path: '/search_result',
                  query: {
                      ...this.$route.query,
                      category: this.selectedValue
                  }
              });
          }

          if(event.target.value) {
              this.getOffers(payload);
          }
      },
      resetPageNumber() {
          this.pageNumber = 1; //reset page number
      },
      onSearchInputChange(merchantName) {
          this.searchTerm = merchantName;
      },
    onSearchChange(merchantName) {
      this.searchTerm = merchantName;
      this.resetPageNumber();

        let payload = {
            PageNumber: this.pageNumber,
            ItemsPerPage: 16,
        };

        if(this.selectedValue != 'all') {
                payload.Category = this.selectedValue;
        }

        if(this.selectedSortValue) {
            payload.SortBy = this.selectedSortValue;
        }

        if(this.searchTerm) {
            payload.MerchantName = this.searchTerm;
        }
      this.getOffers(payload);
    },
      next() {
          this.pageNumber = this.pageNumber + 1;

          let payload = {
              PageNumber: this.pageNumber,
              ItemsPerPage: 16,
          };

          if(this.selectedValue != 'all') {
                  payload.Category = this.selectedValue;
          }

          if(this.searchTerm) {
              payload.MerchantName = this.searchTerm;
          }

          if(this.selectedSortValue) {
              payload.SortBy = this.selectedSortValue;
          }

          this.getOffers(payload);
      },
     getOffers(payload) {

          this.loading = true;
          this.showNoResultsFound = false;
          this.disableScroll();


         if(payload.Category && payload.Category == 'activated') {
             payload.ActiveSc = "ACTIVATED_STATEMENT_CREDIT";
             payload.filter = "activated";

             delete payload.Category;
         }

         let selectedCategory = payload.Category || payload.filter;

      axios.post(this.apiEndPoints.matchedOffers, payload)
        .then((response) => {
          let offers = response?.data?.Response?.Items?.MatchedOffer;

          let currentPage = response?.data?.Response?.CurrentPage;
          let noOfPages = response?.data?.Response?.NumberOfPages;

          if(noOfPages > currentPage) {
              this.showNext = true;
          } else {
              this.showNext = false;
          }

            let currentCategoryMerchantName = selectedCategory +  ( payload.MerchantName || '');

            if (offers !== undefined) {
                if(this.pageNumber > 1 && currentCategoryMerchantName == this.prevCategoryMerchantName) {
                    let currentOffers = this.matchedOffers;
                    this.matchedOffers = {...currentOffers, ...offers};
                } else {
                    this.matchedOffers = {...offers};
                }
            }
        })
        .catch((error) => {
          // console.error(error, 'here');
          // console.error(error.status,'here')
          if (error.response.status == 401 || error.response.status == 419) {
            this.$router.push({ name: 'sign_in' });
          }
        }).finally(() => {
          this.loading = false;
          this.prevCategoryMerchantName = selectedCategory +  (payload.MerchantName || '');
          if(Object.keys(this.matchedOffers).length == 0) {
              this.showNoResultsFound = true;
          }
      });
    },
      disableScroll() {
          // Get the current page scroll position
          let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          let scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

          // if any scroll is attempted,
          // set this to the previous value
          window.onscroll = function () {
              window.scrollTo(scrollLeft, scrollTop);
          };
      },
  },
};
</script>

<style scoped>
    .loading {
        text-align: center;
        position: fixed;
        color: dimgray;
        z-index: 15;
        font-size: 10vw;
        /*background: #5c4084;*/
        /*padding: 8px 18px;*/
        /*border-radius: 5px;*/
        left: calc(50% - 45px);
        top: calc(50% - 18px);
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity 2s
    }
    .fade-enter, .fade-leave-to {
        opacity: 0
    }

    </style>
